"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceOffButton = DeviceOffButton;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var device_1 = require("../../../features/apis/device");
var api_error_message_1 = require("../../../utils/api-error-message");
var button_component_1 = require("../../ui/button-component");
var text_component_1 = require("../../ui/text-component");
// Off ignores every data point the device sends; on turns all of them back on.
function DeviceOffButton(props) {
    var _this = this;
    var device = props.device;
    var _a = (0, react_1.useState)(""), error = _a[0], setError = _a[1];
    var _b = (0, device_1.useSetDeviceOffMutation)(), setDeviceOff = _b[0], isLoading = _b[1].isLoading;
    var requestInFlightRef = (0, react_1.useRef)(false);
    var requestTokenRef = (0, react_1.useRef)(0);
    (0, react_1.useEffect)(function () { return function () {
        requestTokenRef.current += 1;
    }; }, [device.id]);
    var handlePress = function () { return __awaiter(_this, void 0, void 0, function () {
        var requestToken, requestError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (requestInFlightRef.current || isLoading) {
                        return [2 /*return*/];
                    }
                    requestToken = requestTokenRef.current;
                    requestInFlightRef.current = true;
                    setError("");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, setDeviceOff({ id: device.id, off: !device.off }).unwrap()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    requestError_1 = _a.sent();
                    if (requestToken === requestTokenRef.current) {
                        setError((0, api_error_message_1.getApiErrorMessage)(requestError_1, "Unable to update this device. Please try again."));
                    }
                    return [3 /*break*/, 5];
                case 4:
                    requestInFlightRef.current = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: device.off ? "Turn On Device" : "Turn Off Device", icon: "solar:power-linear", variant: "secondary", isPending: isLoading, onPress: handlePress }), error && (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "xsmall", color: "red-600", label: error })] }));
}
